import React, {useEffect, useState} from "react";
import "./MaskedTextBox.scss";
import {MaskedTextBox as KendoMaskedTextBox} from "@progress/kendo-react-inputs";

const MaskedTextBox = (props) => {
  const className = props.className
      ? `${props.className} instream-maskedtextbox`
      : "instream-maskedtextbox";

  const handleChange = (e) => {
    props.onChange(e);
  };

  return (
      <div className={className}>
        <KendoMaskedTextBox
            {...props}
            label={props.label}
            mask={props.mask}
            value={props.value}
            valid={!props.hasError}
            disabled={props.disabled}
            onChange={handleChange}
        />
      </div>
  );
};

export default MaskedTextBox;
